import { FormikProps } from 'formik';
import { ChangeEvent, useState } from 'react';
import { InputSearchFormikDebounce } from '../InputSearchDebounce';

interface ExpandableSearchProps<T> {
    id: string;
    placeholder?: string;
    context: FormikProps<T>;
    className?: string;
    onSearchClick?: (value: string) => void;
    setSearchTerm: (value: string) => void;
    isCloseButtonVisible: boolean;
    closeButtonOnClick: () => void;
    defaultIsExpanded?: boolean;
}

export const ExpandableSearch = <T extends object>({
    id,
    placeholder,
    context,
    className,
    setSearchTerm,
    isCloseButtonVisible,
    closeButtonOnClick,
    defaultIsExpanded = false,
}: ExpandableSearchProps<T>) => {
    const [isExpanded, setIsExpanded] = useState(defaultIsExpanded);
    const [focusInput, setFocusInput] = useState(false);

    const handleBlur = () => {
        setFocusInput(false);
    };

    const handleSearchChange = (e: ChangeEvent<HTMLInputElement>) => {
        setSearchTerm(e.target.value);
    };
    return (
        <>
            {!isExpanded ? (
                <img src="/svg/common/search.svg" alt="Search" className="button-pointer" onClick={() => setIsExpanded(true)} />
            ) : (
                <InputSearchFormikDebounce
                    id={id}
                    placeholder={placeholder}
                    context={context}
                    className={className || ''}
                    isCloseButtonVisible={isCloseButtonVisible}
                    closeButtonOnClick={closeButtonOnClick}
                    searchButtonOnClick={() => {}}
                    onChange={handleSearchChange}
                    onBlur={handleBlur}
                    shouldFocus={focusInput}
                />
            )}
        </>
    );
};
